import { useState } from 'react'
import axios from 'axios'

import { API_BASE_URL } from '../config/api'

export const useArtistStats = () => {
  const [selectedArtist, setSelectedArtist] = useState('')
  const [artistStats, setArtistStats] = useState(null)
  const [error, setError] = useState('')

  const handleArtistSelect = async (artistName) => {
    if (!artistName) {
      setSelectedArtist('')
      setArtistStats(null)
      setError('')
      return
    }

    try {
      setSelectedArtist(artistName)
      setError('')
      const response = await axios.get(
        `${API_BASE_URL}/api/events/artist-stats/${encodeURIComponent(artistName)}`,
        { withCredentials: true }
      )
      setArtistStats(response.data)
    } catch (error) {
      setError('Failed to load artist stats')
      if (process.env.NODE_ENV === 'development') console.error('Artist stats error:', error)
      setArtistStats(null)
    }
  }

  return {
    selectedArtist,
    artistStats,
    error,
    handleArtistSelect
  }
}